import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import { StateProvider } from './utils/store';

ReactDOM.render(
	<StateProvider>
		<App />
	</StateProvider>,
	document.getElementById('root')
);
